import { AuthService } from './../core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from "../core/services/user.service";
import { User } from "../core/models/user.model";
import { Location } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit {

    public user: User;

    get isLoggedIn(): boolean {
        return this.authService.isAuthenticated;
    }

    constructor(
        private router: Router,
        private userService: UserService,
        private authService: AuthService
    ) {
    }

    ngOnInit(): void {

        // TODO: Move this logic in user or auth service to get current user
        if (this.isLoggedIn) {

            this.userService.getLoggedInUser().subscribe(

                response => {
                    this.user = response;
                },

                error => {
                    this.user = null;
                }

            );
        }
    }

    logout() {

        this.user = null;

        this.userService.purgeAuth();

        this.router.navigateByUrl('/login');

    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/layout/header.component.ts